import axios from "axios";
import { ID_TOKEN, TOKEN_EXP, USER_DATA } from "../config/app.config";
import { VARNISH_URL } from "../config/api.config";

const httpAuth2 = axios.create({
  baseURL: VARNISH_URL,
  headers: {
    Accept: 'application/json',
    authorization: '',
  },
})



const clearToken = () => {
  setTimeout(() => {
    window.location.reload()
  }, 3000)

  window.onunload = function () {
    localStorage.removeItem(ID_TOKEN)
    localStorage.removeItem(USER_DATA)
    localStorage.removeItem(TOKEN_EXP)
    localStorage.setItem('isLogin', false)
  }
}

httpAuth2.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(`${ID_TOKEN}`)
    const token_exp = localStorage.getItem(TOKEN_EXP)
    const isLogin = localStorage.getItem('isLogin')

    if (!token && isLogin === 'true') {
      clearToken()
      throw new Error('Response has no token')
      return
    }

    if (token_exp && new Date((token_exp - 5) * 1000) < new Date()) {
      clearToken()
    }

    config.headers.authorization = `${token}`
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for API calls
httpAuth2.interceptors.response.use(
  (response) => {
    return response
  },
  async function (error) {
    if (error.response?.status === 403 || error.response?.status === 401) {
      const localToken = localStorage.getItem(ID_TOKEN)

      // if (localToken) {
      //   clearToken()
      // }
      if (localToken)
        setTimeout(() => {
          window.location.reload()
        }, 3000)

      localStorage.removeItem(ID_TOKEN)
      localStorage.removeItem(USER_DATA)
      localStorage.removeItem(TOKEN_EXP)
      localStorage.setItem('isLogin', false)
    }

    return Promise.reject(error)
  }
)

export default httpAuth2
